import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const OfflineBanner: React.FC = () => {
    const { t } = useTranslation();
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (isOnline) return null;

    return (
        <div className="bg-yellow-500 text-white p-2 text-center text-sm font-bold sticky top-0 z-50 shadow-md">
            {t('offline_mode_warning', 'You are currently offline. Using cached data.')}
        </div>
    );
};

export default OfflineBanner;
